import InventoryEdit from './InventoryEdit'
export default InventoryEdit
